import React, { useEffect, useState } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AOS from "aos";
import "aos/dist/aos.css";
import AdminSidebar from "../Side/AdminSidebar";
import { useAuth } from "../Auth/AuthContext";
import Loader from "../Animations/Loader";
import * as XLSX from "xlsx";
import axios from "axios"; // Import axios
import { baseUrl as apiBaseUrl } from '../../config/appsettings';

const AppReports = () => {
    const { authState } = useAuth();
    const role = authState.roles;
    const admin = role === "Admin";
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const baseUrl = apiBaseUrl + 'reports';

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
        setLoading(false);
    }, []);
    const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
        const binaryStr = event.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Convert full sheet to JSON
        const parsedData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        // Skip rows until we find the header row that includes "Ad unit"
        const headerIndex = parsedData.findIndex(row =>
            Object.values(row).some(cell =>
                typeof cell === "string" &&
                cell.toLowerCase().includes("ad unit")
            )
        );

        // Slice from header to end (skip metadata rows)
        const cleanData = parsedData.slice(headerIndex + 1);

        setData(cleanData); // Update table preview

        // Send to backend
        try {
            const response = await axios.post(`${baseUrl}/appupload`, cleanData, {
                headers: { "Content-Type": "application/json" },
            });

            console.log("Report uploaded successfully:", response.data);
            alert("Report uploaded successfully!");
        } catch (error) {
            console.error("Error uploading report:", error);
            alert("Failed to upload the report.");
        }
    };

    reader.readAsBinaryString(file);
};


    if (loading) {
        return <Loader />;
    }

    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            {admin ? <AdminSidebar /> : <Sidebar />}
            <div className="flex-1 bg-gray-100">
                <div className="flex-1 flex flex-col">
                    <Topbar />
                    <main className="pt-[60px] px-4">
                        <div className="mt-6 p-4 bg-white shadow rounded-lg">
                            <h2 className="text-xl font-semibold mb-4">Upload and View Excel Report</h2>
                            <input type="file" accept=".xls,.xlsx" onChange={handleFileUpload} className="mb-4" />
                            {data.length > 0 && (
                                <div className="overflow-x-auto mt-4">
                                    <table className="min-w-full bg-white border border-gray-200">
                                        <thead>
                                            <tr className="bg-gray-200 text-gray-700">
                                                {Object.keys(data[0]).map((key) => (
                                                    <th key={key} className="px-4 py-2 border">{key}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((row, rowIndex) => (
                                                <tr key={rowIndex} className="border">
                                                    {Object.values(row).map((cell, cellIndex) => (
                                                        <td key={cellIndex} className="px-4 py-2 border">{cell}</td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AppReports;